// Utilidades para mostrar y guardar archivos descargados de la API (adjuntos y documentos)

export function extension(nombre) {
  const m = /\.([a-z0-9]{1,5})$/i.exec(nombre || "");
  return m ? m[1].toLowerCase() : "";
}

/** 'pdf', 'image' u 'otro', mirando el contenido real (muchos archivos no llevan extensión en el nombre) */
export async function tipoDe(blob, item = {}) {
  const cabecera = await blob.slice(0, 5).text().catch(() => "");
  const ext = extension(item.ruta) || extension(item.nombre_archivo) || extension(item.name);
  if (cabecera.startsWith("%PDF") || blob.type.includes("pdf") || ext === "pdf") return "pdf";
  if (blob.type.startsWith("image/") || ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(ext)) return "image";
  return "otro";
}

/** Nombre con el que se guarda: el del archivo y, si no la tiene, la extensión que le corresponde */
export function nombreDescarga(item, blob) {
  const nombre = (item.name || `archivo-${item.id}`).trim();
  if (extension(nombre)) return nombre;
  const porTipo = { "application/pdf": "pdf", "image/png": "png", "image/jpeg": "jpg", "image/gif": "gif", "text/plain": "txt" };
  // ruta: archivo local; nombre_archivo: archivo original en el portal de Quesos
  const ext = extension(item.ruta) || extension(item.nombre_archivo) || porTipo[blob?.type] || "";
  return ext ? `${nombre}.${ext}` : nombre;
}

/** Guarda el blob en el equipo con su nombre */
export function guardarArchivo(item, blob) {
  if (!item || !blob) return;
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement("a");
  enlace.href = url;
  enlace.download = nombreDescarga(item, blob);
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60 * 1000);
}
